export const OmnipodConstants = {
  DASH_API_DEVICE_NAME: "omnipod dash",
  EROS_API_DEVICE_NAME: "omnipod eros",
  EROS_DISPLAY_NAME: "Omnipod®",
  DASH_DISPLAY_NAME: "Omnipod DASH®",
  EROS_USB_IDS: { vendorId: 7734, productId: 2 },
  DASH_USB_IDS: { vendorId: 3725, productId: 8221 },
  HISTORY_LOG_FLAGS: {
    /**
     * TODO: look for this flag and use it to identify
     *   extended boluses split over midnight instead of uploading
     *   them separately and annotating the extended with the
     *   'insulet/bolus/split-extended' code as we're doing now
     */
    CARRY_OVER_FLAG: 0b0000_0000_0000_0001,
    NEW_DAY_FLAG: 0b0000_0000_0000_0010,
    /**
     * Represents an "in-progress" flag status.
     * This flag means the record is currently ongoing or not yet completed.
     * Filter out logs with this flag
     */
    IN_PROGRESS_FLAG: 0b0000_0000_0000_0100,
    END_DAY_FLAG: 0b0000_0000_0000_1000,
    /**
     * Represents an unconfirmed flag.
     * This flag means the record has not been confirmed ?
     * Filter out logs with this flag
     */
    UNCOMFIRMED_FLAG: 0b0001_0000,
    REVERSE_CORR_FLAG: 0b0000_0001_0000_0000,
    MAX_BOLUS_FLAG: 0b0000_0010_0000_0000,
  },
};
